import React from "react";
import { Image } from "@sparefoot/react-commons";
import { Text } from "components/core/Typography";
import image from "assets/images/reviews-heart.svg";
import ReviewCard from "components/sdc/PaidLanding/ReviewsSection/ReviewCard";
import { REVIEWS_CARDS_DATA } from "../PaidLandingData";
import "./ReviewsSection.scss";

function ReviewsSection() {
	return (
		<div className="reviews-section">
			<Image
				src={image}
				alt="icon"
				width="67px"
				height="67px"
			/>
			<div className="heading">
				<Text
					color="white"
					size="xxlarge"
					weight="bold"
				>
					97% of Reviewers Have Given Us a <br />
					<Text color="lightBlue">
						4 out of 5 Star Rating or Higher
					</Text>{" "}
					on Trustpilot!
				</Text>
			</div>
			<div className="review-cards">
				{REVIEWS_CARDS_DATA.map((data) => (
					<ReviewCard {...data} />
				))}
			</div>
		</div>
	);
}

export default ReviewsSection;
